import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-line-chart-line',
    title: 'マーケティング支援',
    desc: '美容製品・サービスのマーケティング戦略立案から実行まで、トータルでサポートいたします。SNS運用、広告戦略、ブランディングなど幅広く対応。',
    color: 'bg-sky-50',
    iconColor: 'text-sky-400',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '情報提供・コンサルティング',
    desc: '最新の美容トレンドと業界知識を活かした、実践的なコンサルティングを提供します。ビジネスの課題を一緒に解決します。',
    color: 'bg-sky-50',
    iconColor: 'text-sky-400',
  },
  {
    icon: 'ri-computer-line',
    title: 'オンライン講座・セミナー',
    desc: '美容ビジネスに必要な知識とスキルを学べる、実践的なプログラムを企画・運営しています。初心者から上級者まで対応。',
    color: 'bg-sky-50',
    iconColor: 'text-sky-400',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">Our Services</span>
          <h2 className="text-3xl md:text-4xl font-light text-slate-800 mt-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            私たちの<span className="font-semibold">サービス</span>
          </h2>
          <div className="w-12 h-0.5 bg-sky-300 mx-auto mt-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className={`${s.color} rounded-2xl p-8 hover:scale-[1.02] transition-transform duration-300 cursor-default`}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white mb-6">
                <i className={`${s.icon} ${s.iconColor} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-800 mb-3">{s.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-sky-400 text-sm font-medium hover:text-sky-500 transition-colors cursor-pointer"
          >
            サービス詳細を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
